<template>
  <div class="page" v-wechat-title="$route.meta.title='所有景区'">
    <div class="station-top-bar border-box box">
      <router-link class="station-location" v-if="!siteid || !sregion" to="/city">
        <span class="station-location-name">{{cityInfo.city || '全国'}}</span>
        <img class="station-location-icon" src="../../assets/icon-down.png" alt="">
      </router-link>

      <div class="station-search-box flex">
        <form class="station-search-bar border-box" v-on:submit.prevent="search">
          <img class="station-search-icon" src="../../assets/icon-search.png" alt="" @click='search'>
          <input type="text" class="station-search-input"  placeholder="搜索景区" value="" v-model='inputValue' />
          <img class="station-input-close" src="../../assets/input-close.png" alt="" v-show="inputValue"  @click="inputValue=''">
        </form>
      </div>
    </div>

    <div class="conference-list p024 clearfix">
      <template v-for="(item,index) in root">
        <div  class="conference-item-parent" @click="toViewDetail(item.id,item.shopType)">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <span class="conference-item-hover-text">讲解点{{item.spotnum}}个</span>
            <div class="conference-item-info clearfix">
              <div class="label-box fl">
                <div class="fl conference-item-title hide" :style="latlng.lat==''?'max-width:100%;':''">{{item.name}}</div>
                <div class="fl left-info" v-if="item.juli!='...'&&latlng.lat!=''">
                  <img class="conference-item-address-icon" src="../../assets/station-icon-adress.png" alt="">
                  <span class="conference-item-rote">{{item.juli|initDistance}}</span>
                </div>
              </div>
              <div v-if="item.listen>0" class="fr lineH60 right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-listen.png" alt="">
                  <span class="icon-time">{{item.listen|initNumber}}</span>
                </div>
                <div v-if="item.buys>0" class='conference-item-info-label'>
                  <img src="../../assets/station-icon-buy.png" alt="">
                  <span class="icon-time">{{item.buys|initNumber1}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>
  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {getHome} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        sregion: '', //省站点id
        siteid: '', //站点id
        userInfo: {}, //用户信息
        lat: this.$route.query.lat || '',
        lng: this.$route.query.lng || '',
        latlng: {lat: '', lng: '' }, //经纬度信息
        cityInfo: {}, //城市信息
        root:[],//景区列表
        total: '',//景区总数
        inputValue: '',//搜索关键词
        sort: this.$route.query.sort || 1, //0:热门 1:距离排序
        page: 1,
        rows: 7,
        loadText: "数据加载中",

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        appKeyA: ''
      }
    },
    computed: {

    },
    created() {
      let self = this;

      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.inputValue = this.$route.query.inputValue.replace(/(^\s*)|(\s*$)/g, "") || "";
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if(this.siteid != "" && this.siteid != null && this.siteid != undefined ){
        setStore("siteid",this.siteid);
      }
      this.userInfo = getStore("userInfo");
      this.sregion = getStore("sregion") || '';

      let cityInfo = getStore("cityInfo");
      if(cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == ""  ){
        getCityInfo(function(res){
          self.latlng = res;
          self.cityInfo = getStore("cityInfo");
          self.initData(self.page);
        });
      }else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function(res){
          self.latlng ={ lat: res.latitude, lng: res.longitude };
          self.initData(self.page);
        });
      }

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {

      async initData(page){

        let res = await getHome({
          TimeStamp: this.TimeStamp,
          siteid: this.siteid,
          code: this.cityInfo.citycode || '1',
          lat: this.lat || this.latlng.lat || '',
          lng: this.lng || this.latlng.lng || '',
          page: page,
          rows: this.rows,
          type: this.sort,
          onlyshop: 1, //1:需要景区数据
          onlybag: 0, //1:需要导游数据
          name: this.inputValue, //搜索关键词
          cid: '', //导游筛选
          openid: this.userInfo.openid,
          sregion: this.sregion
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = this.userInfo.name + '@你：';
          let desc = '我正在“金牌解说”，一起来听景区故事吧';
          let link = '/view-list?siteid='+ this.siteid +'&TimeStamp='+ this.TimeStamp +'&inputValue='+ this.inputValue+'&appKey='+(this.appKey);
          wxShareme(title,desc,"",link);

        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //发送搜索信息inputVaule
      search(){
        this.$loading.show('数据加载中');
        this.page = 1;
        this.root = [];
        this.initData(this.page);
      },

      toViewDetail(id,shopType){
        if(shopType == "buddhism"){
          this.$router.push({
            path: `/view-detail-sm?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }if(shopType == "bagscenic"){
          this.$router.push({
            path: `/view-detail-group?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }else {
          this.$router.push({
            path: `/view-detail?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }

      },

    },
    watch:  {
      'cityInfo.citycode'(newVal,oldval){
        if(newVal != oldval){
//          this.initData();
        }
      },
    },
    components: {

    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      initDistance: function (num) {
        if(num>1000){
          num = (num/1000).toFixed(2)+'KM'
        }
        return num;
      },
      initNumber1: function (num) { //重置购买数据
        if(num>1000){
          num = '1000+'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/view.css";
  .page{padding-top: 1rem;}
</style>



// WEBPACK FOOTER //
// src/page/view-list/view-list.vue